import React from "react";
import { connect } from "react-redux";
import {Scrollbar} from "react-scrollbars-custom";
import { focusChannel, openChannel, alertError, stopIgnoringChannel, confirm } from "actions/ui";
import { markRecentChatRead } from "actions/application";
import { sendUserCommand, clearUserCommand } from "actions/commands";
import Time from "ui/common/channel/messages/message/Time";
import Decorator from "ui/common/channel/messages/message/Decorator";
import PropTypes from "prop-types";

class RecentChatsWithCurrentMode extends React.Component {

	constructor(props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
		this.handleAvatarError = this.handleAvatarError.bind(this);
	}

	handleAvatarError(e) {
		e.target.src = this.props.configuration.baseDir + '/gfx/icons/user.png';
	}

	componentDidMount() {
		this.props.clearUserCommand('recent');
	}

	componentDidUpdate(prevProps) {
		const commandFailure = this.props.command !== prevProps.command && this.props.command && this.props.command.success === false;

		if (commandFailure) {
			this.props.alertError(this.props.command.error);
			this.props.clearUserCommand('recent');
		}
	}

	handleClick(recentChat) {
		if (this.props.ignoredChannels.includes(recentChat.channel.id)) {
			this.props.confirm(this.props.i18n.ignoredInfo, function () {
				this.props.stopIgnoringChannel(recentChat.channel.id);
				this.openRecentChat(recentChat);
			}.bind(this));
		} else {
			this.openRecentChat(recentChat);
		}
	}

	openRecentChat(recentChat) {
		this.props.openChannel(recentChat.channel.id);
		this.props.focusChannel(recentChat.channel.id);

		if (!recentChat.read) {
			this.props.markRecentChatRead(recentChat.channel.id);
			this.props.sendUserCommand('recent', 'markChannelAsRead', {channel: recentChat.channel.id});
		}

		if (this.props.onClick) {
			this.props.onClick(recentChat);
		}
	}

	getOpenedChannels() {
		return this.props.openedChannels
			.filter( channelId => this.props.channels.find( channel => channel.id === channelId && channel.type === 'direct') )
			.map( channelId => this.props.channels.find( channel => channel.id === channelId) )
			.map( channel => ({ read: true, channel: channel }));
	}

	renderEntry(recentChat, index, array) {
		const uiChannel = this.props.uiChannels[recentChat.channel.id];

		return <div key={ recentChat.channel.id } className={ 'wcRecent ' + (recentChat.read ? 'wcRead' : 'wcUnread' ) + (index === 0 ? ' wcFirst' : '') + (index + 1 === array.length ? ' wcLast' : '') } onClick={ e => this.handleClick(recentChat) }>
			{ this.props.configuration.interface.recent.status &&
				<React.Fragment>
					{ recentChat.channel.online === true
						? (<span className="wcStatus wcOnline" />)
						: (<span className="wcStatus wcOffline" />)
					}
				</React.Fragment>
			}

			{recentChat.channel.avatar &&
				<img src={recentChat.channel.avatar} onError={ this.handleAvatarError } className="wcFunctional wcRecentChatAvatar" alt={recentChat.channel.name} />
			}

			<div className="wcRight">
				<div className="wcHead">
					<span className="wcName">
						{ recentChat.channel.name }
						{ uiChannel && uiChannel.unread > 0 && <span key={ uiChannel.unread } className="wcUnreadMessagesCount wcAnimationFlash">{ uiChannel.unread }</span> }
					</span>
					{ recentChat.timeUTC &&	<Time timeUTC={ recentChat.timeUTC } /> }
				</div>
				{ this.props.configuration.interface.recent.excerpts && recentChat.text &&
					<span className="wcText"><Decorator>{ recentChat.text }</Decorator></span>
				}
			</div>
		</div>
	}

	render() {
		if (!this.props.configuration.interface.recent.enabled) {
			return null;
		}

		const openedDirectChannels = this.getOpenedChannels();
		const recentChats = this.props.recentChats.filter( recentChat => !this.props.openedChannels.includes(recentChat.channel.id) );
		const unreadChats = recentChats.filter( recentChat => !recentChat.read );
		const chatsArchive = recentChats.filter( recentChat => recentChat.read );

		return(
			<div className="wcRecentChats">
				{ (recentChats.length > 0 || openedDirectChannels.length > 0) ? (
					<Scrollbar noScrollX={ true }>
						{openedDirectChannels.length > 0 &&
							<React.Fragment>
								<div className="wcHeader wcUnreadMessages">{ this.props.i18n.openChats } </div>
								{ openedDirectChannels.map( (chat, index, array) => this.renderEntry(chat, index, array) ) }
							</React.Fragment>
						}

						{ unreadChats.length > 0 && <div className="wcHeader wcUnreadMessages">{ this.props.i18n.unreadChats } </div> }
						{ unreadChats.map( (recentChat, index, array) => this.renderEntry(recentChat, index, array) ) }
						{ chatsArchive.length > 0 && <div className="wcHeader wcReadMessages">{ this.props.i18n.chatsArchive } </div> }
						{ chatsArchive.map( (recentChat, index, array) => this.renderEntry(recentChat, index, array) ) }
					</Scrollbar>
				):(
					<span className="wcNoRecent">{ this.props.i18n.noRecentChats }</span>
				)}
			</div>
		);
	}

}

RecentChatsWithCurrentMode.propTypes = {
	onClick: PropTypes.func,
	keepInside: PropTypes.string,
	infoWindowPosition: PropTypes.string.isRequired
};

export default connect(
	(state) => ({
		i18nBase: state.configuration.i18n,
		i18n: state.application.i18n,
		configuration: state.configuration,
		channels: state.application.channels,
		recentChats: state.application.recentChats,
		openedChannels: state.ui.openedChannels,
		command: state.commands.sent.recent,
		ignoredChannels: state.ui.ignoredChannels,
		uiChannels: state.ui.channels
	}),
	{ focusChannel, openChannel, alertError, sendUserCommand, clearUserCommand, markRecentChatRead, stopIgnoringChannel, confirm }
)(RecentChatsWithCurrentMode);